var allowedProtocols = new Set(["http:", "https:"]);
export var validateExternalUrl = function (rawUrl) {
    if (!(rawUrl === null || rawUrl === void 0 ? void 0 : rawUrl.trim())) {
        return {
            isValid: false,
            message: "Link indisponível.",
        };
    }
    try {
        var parsedUrl = new URL(rawUrl.trim());
        if (!allowedProtocols.has(parsedUrl.protocol)) {
            return {
                isValid: false,
                message: "Link inválido ou indisponível.",
            };
        }
        return {
            isValid: true,
            url: parsedUrl.toString(),
        };
    }
    catch (_a) {
        return {
            isValid: false,
            message: "Link inválido ou indisponível.",
        };
    }
};
export var openExternalUrlSafely = function (rawUrl) {
    var validation = validateExternalUrl(rawUrl);
    if (!validation.isValid || !validation.url) {
        return false;
    }
    window.open(validation.url, "_blank", "noopener,noreferrer");
    return true;
};
